import React, { useState } from 'react';
import { Home } from 'lucide-react';
import imageService from '../services/imageService';

const PropertyImage = ({ 
  property, 
  className = "w-full h-48", 
  width = 400, 
  height = 300,
  alt = "Property",
  showPlaceholder = true 
}) => {
  const [imageLoaded, setImageLoaded] = useState(false);
  const [imageError, setImageError] = useState(false);

  // Check all possible image field names
  const getImageUrls = (property) => {
    if (!property) return null;
    
    // Try all possible field names
    const possibleFields = [
      'afbeeldingURLs',
      'imageUrls', 
      'fotos',
      'images',
      'photos',
      'afbeeldingen'
    ];
    
    for (const field of possibleFields) {
      if (property[field] && Array.isArray(property[field]) && property[field].length > 0) {
        return property[field];
      }
    }
    
    return null;
  };

  const imageUrls = getImageUrls(property);
  
  if (!imageUrls || imageUrls.length === 0) {
    if (!showPlaceholder) return null;
    
    return (
      <div className={`${className} bg-gradient-to-br from-[#EEF6FF] via-[#F5FAFF] to-[#F0F7FF] flex items-center justify-center`}>
        <div className="text-center">
          <div className="w-12 h-12 bg-white/90 border border-[#5EABEB]/20 rounded-full flex items-center justify-center mx-auto mb-2 shadow-sm">
            <Home className="w-6 h-6 text-[#5EABEB]/70" />
          </div>
          <span className="text-slate-500 text-xs font-medium">Geen foto</span>
        </div>
      </div>
    );
  }

  // Get the first image URL
  const firstImageUrl = imageUrls[0];
  
  // Get optimized URL for Firestore Storage
  const optimizedUrl = imageService.getOptimizedImageUrl(firstImageUrl, width, height);
  
  if (imageError) {
    return (
      <div className={`${className} bg-gradient-to-br from-[#EEF6FF] via-[#F5FAFF] to-[#F0F7FF] flex items-center justify-center`}>
        <div className="text-center">
          <div className="w-12 h-12 bg-white/90 border border-[#5EABEB]/20 rounded-full flex items-center justify-center mx-auto mb-2 shadow-sm">
            <Home className="w-6 h-6 text-[#5EABEB]/70" />
          </div>
          <span className="text-slate-500 text-xs font-medium">Foto niet gevonden</span>
        </div>
      </div>
    );
  }

  return (
    <div className={`relative ${className}`}>
      {!imageLoaded && !imageError && (
        <div className="absolute inset-0 bg-gradient-to-br from-gray-100 to-gray-200 flex items-center justify-center">
          <div className="text-center">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mx-auto mb-2"></div>
            <span className="text-gray-500 text-xs">Laden...</span>
          </div>
        </div>
      )}
      
      <img
        src={optimizedUrl}
        alt={property?.titel || property?.title || property?.adres || alt}
        className={`w-full h-full object-cover ${imageLoaded ? 'opacity-100' : 'opacity-0'} transition-opacity duration-300`}
        loading="lazy"
        onError={() => {
          console.log('Image failed to load:', optimizedUrl);
          setImageError(true);
        }}
        onLoad={() => {
          console.log('Image loaded successfully:', optimizedUrl);
          setImageLoaded(true);
        }}
      />
    </div>
  );
};

export default PropertyImage;
